import { render, staticRenderFns } from "./templateProductModel.vue?vue&type=template&id=886fa678&scoped=true"
import script from "./templateProductModel.vue?vue&type=script&lang=js"
export * from "./templateProductModel.vue?vue&type=script&lang=js"
import style0 from "./templateProductModel.vue?vue&type=style&index=0&id=886fa678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886fa678",
  null
  
)

export default component.exports